import React from 'react';

import { formatNumber } from '../../../utils/number';

interface TransportNumberProps {
    value: number | null;
}

/**
 * Транспортный габарит в строке справочника.
 *
 * Прочерк означает, что значения нет: запись заведена до доработки, либо
 * классификатор ещё не отработал по этой позиции. Доставка в этом случае
 * считается по габаритам товара из верхней строки.
 */
export function TransportNumber({ value }: TransportNumberProps) {
    if (value === null || value === 0) return <>—</>;

    return <>{formatNumber(value)}</>;
}
